'use client';

import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { isClient } from '@fe-common-utils/libs/utils';
import { CSSProperties, styled } from '@linaria/react';
import { memo, useEffect } from 'react';
import Skeletion from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const LITV_ID = 'ppn-Y3ky|Y3k=-0';
const LITV_CONTAINER_HEIGHT = 515;

declare global {
  interface Window {
    ppnio: unknown[];
  }
}

const View = styled.div`
  margin: 40px 0;
  width: 100%;
  height: ${LITV_CONTAINER_HEIGHT}px;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    margin: 0;
    height: auto;
  }

  @media screen and (max-width: ${SCREEN_SIZE.MOBILE - 1}px) {
    margin: 0;
    height: auto;
  }
`;

const LiTV = ({ litvId = LITV_ID, containerStyle = {} }: { litvId?: string; containerStyle?: CSSProperties }) => {
  useEffect(() => {
    if (isClient) {
      window.ppnio = window.ppnio || [];
      window.ppnio.push(litvId);
    }
  }, [litvId]);

  return (
    <section id='LiTV'>
      <View id={litvId} style={containerStyle}>
        <Skeletion height={LITV_CONTAINER_HEIGHT} />
      </View>
      {/* 安裝LiTV */}
      <script async src='https://player.svc.litv.tv/v3/ppnio.js' />
    </section>
  );
};

export default memo(LiTV);
